import { Component, OnInit, Output,EventEmitter,Input, OnDestroy } from '@angular/core';
import {LoginService} from '../login.service';
import {Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommerrorService } from '../commerror.service';
import { ExamsService } from '../exams.service';
import { SignatureService } from '../signature.service';
import { Exam } from '../interfaces/exams.service/types'

@Component({
    selector: 'app-loginbox',
    templateUrl: './loginbox.component.html',
    styleUrls: ['./loginbox.component.scss'],
    standalone: false
})
export class LoginboxComponent implements OnInit, OnDestroy {

  user: string;
  pw: string;
  error: string;
  code: string;
  hideButton=false;
  @Output() closed = new EventEmitter<null>();
  @Output() viewonly = new EventEmitter<null>();
  @Input('isnew') newexam:boolean;
  @Input('isExport') export:boolean = false;
  @Input('search') search:boolean = false;


  private destroy$ = new Subject();
  hidepw=true;
  typed=false;

  constructor(
    public loginService: LoginService,
    public errorMessage: CommerrorService,
    public examService: ExamsService,
    public signatureService: SignatureService,
  ) {}

  ngOnInit() {
    // Username prefilled, password deliberately NOT. Hashed accounts have no
    // plaintext left to prefill, so loginService.pw is undefined for them and
    // the field only ever looked filled for legacy users. Re-authentication
    // should ask for the password anyway -- that is what it is for.
    this.user = this.loginService.loginname;
    this.loginService.onFailedLogin.pipe(takeUntil(this.destroy$)).subscribe(()=>{
      this.hideButton = false;
    });
  }

  async checkLogin(unSignExam: boolean = false){
    if(! this.loginService.getCode){
      if(this.loginService.loginname != this.user && ! this.loginService.contLogin)
        this.errorMessage.error("you are trying to start a new exam with another user’s credentials, the exam report will be signed with the other user’s name,  do you want to continue? if not please log out from the app session and log in again",true);
      else{
        this.hideButton = true;
        if (unSignExam) {
          (await this.signatureService.unSignExam(this.examService.examID)).subscribe((data: Exam) => {
            this.signatureService.examUnSigned$.next(data);
          });
        }
        this.loginService.examLogin(this.user,this.pw,true,this.export); // Use examLogin to skip 2fa
      }
    }
    else
      this.loginService.sendCode(this.code);
  }

  clean(){
    try{
      this.user = this.user.replace(/[^\x00-\x7F]+/, '')
      this.pw = this.pw.replace(/[^\x00-\x7F]+/, '')
    }
    catch{}
  }

  ngOnDestroy(){
    this.destroy$.next(undefined);
  }

}
